import AxiosClient from "../../services/axios.services";

class CalendarEmployeeServices {
  getSelectSearch = (endpoint, params) =>
    AxiosClient.get(endpoint, {
      headers: { "Content-Type": "application/json" },
      params: params,
  });
}

export default new CalendarEmployeeServices();